import * as dateFiltersSetters from './store/date-filters-setters'
import * as dateFiltersGetters from './store/date-filters-getters'
import * as searchSetters from './store/searchStore-setters'
import * as search from './search'
import formatDate from './../reusable/format-date'
import moment from 'moment'

const setDateRange =  () => {
  let dateFrom = dateFiltersGetters.getDateFrom()
  let dateTo = dateFiltersGetters.getDateTo()
  let dateStart = dateFiltersGetters.getDateStart()
  let dateEnd = dateFiltersGetters.getDateEnd()
  let dateFromStatic = dateFiltersGetters.getDateFromStatic()
  let dateToStatic = dateFiltersGetters.getDateToStatic()

  // when one of dates is empty the default value is set
  if (dateFrom == '') {
    dateFiltersSetters.setDateFrom(dateStart)
  }
  if (dateTo == '') {
    dateFiltersSetters.setDateTo(dateEnd)
  }

  setDateGap(dateFiltersGetters.getDateFrom(), dateFiltersGetters.getDateTo())

  // set number of items per page to default
  searchSetters.resetRows()
  // set page start to default
  searchSetters.resetPageStart()

  if (dateFrom != dateFromStatic || dateTo != dateToStatic) {
    search.loadResults()
  }
}

const resetDateRange = () => {
  // reset date range in store
  dateFiltersSetters.resetDateRange()
  // loads results without date
  search.loadResultsWithDataPreload()
}

const setDateActive = (start, end) => {
  dateFiltersSetters.setDateFromActive(start)
  dateFiltersSetters.setDateToActive(end)
}

const setDateGap = (start, end) => {
  dateFiltersSetters.setDateGap({
    start: start,
    end: end
  })

}

const setToArr = (start, end) => {
  dateFiltersSetters.setToDateArr({
    start: start,
    end: end
  })
}

const isDate = (value, position, defaultDate) => {
  // regex for digit and dots
  const re = /^\d{1,4}|\.$/;

  if (re.test(value)) {
    // adding zeros to digits function
    Number.prototype.zeroPad = function(length) {
      length = length || 2; // defaults to 2 if no parameter is passed
      return (new Array(length).join('0')+this).slice(length*-1);
    };

    let date = value.split('.').reverse(),
        day = (date[2]) ? date[2] : '1',
        month = (date[1]) ? date[1] : '1',
        year = (date[0].length < 4) ? ('000' + date[0]).slice(-4) : date[0],
        MOMdate, MOMday, MOMmonth, MOMyear

    // prevent for last day or/and last month of month/year
    if (position == 'TO') {
      if (!date[1] && !date[2]) {
        day = 31
        month = 12
      }

      if (!date[2]) {
        let dayMOMdate = moment().set({'year': year, 'month': month, 'date': 1})
        day = dayMOMdate.subtract(1, 'day').get('date')
      }
    }

    // build moment date
    MOMdate = moment(year + '-' + month + '-' + day, 'YYYY-MM-DD');

    // check the date is valid
    if (MOMdate.isValid()) {
      MOMday = MOMdate.get('date')
      MOMmonth = MOMdate.get('month') + 1
      MOMyear = MOMdate.get('year')

      dateFiltersSetters.setValidDate(position, true)
      return MOMyear.zeroPad(4) + '-' + MOMmonth.zeroPad() + '-' + MOMday.zeroPad()

    } else {
      dateFiltersSetters.setValidDate(position, false)
      return value
    }
  } else {

    return defaultDate
  }
}

const setValidDates = () => {
  // set the dates as valid
  dateFiltersSetters.setValidDate('FROM', true)
  dateFiltersSetters.setValidDate('TO', true)
}

const momentDateValid = (objectDate) => {
  // fix date format
  return (moment(objectDate,'DD.MM.YYYY').isValid()) ? moment(objectDate,'DD.MM.YYYY').format('YYYY-MM-DD') : objectDate
}

const momentDateRangeValidDateFrom = (dateStart, dateEnd, dateDefault) => {
  // validation of entered range for dateFrom
  return ((moment(dateStart).isAfter(dateDefault) && moment(dateStart).isBefore(dateEnd)) || moment(dateStart).isSame(dateEnd)) ? dateStart : dateDefault
}

const momentDateRangeValidDateTo = (dateStart, dateEnd, dateDefault) => {
  // validation of entered range for dateTo
  return ((moment(dateEnd).isAfter(dateStart) && moment(dateEnd).isBefore(dateDefault)) || moment(dateEnd).isSame(dateStart)) ? dateEnd : dateDefault
}

const momentCheckDateFromDateTo = (dateStart, dateEnd) => {
  // check the dateEnd is after dateStart
  let checkDate = moment(dateEnd).isAfter(dateStart)
  dateFiltersSetters.setCheckDate(checkDate)

  return checkDate
}

export {
  setDateRange,
  setDateActive,
  resetDateRange,
  setDateGap,
  setToArr,
  isDate,
  setValidDates,
  momentDateValid,
  momentDateRangeValidDateFrom,
  momentDateRangeValidDateTo,
  momentCheckDateFromDateTo
}



// WEBPACK FOOTER //
// ./src/scripts/modules/date-filter.js